import type {
  DRAGGABLE_TYPE,
  DROPZONE_TYPE,
} from '@components/ArtBoard/DragAndDrop/types'
import type { ID, WithId } from '@octopus-do/octopus-project-core'
import { createAction } from '@reduxjs/toolkit'
import type {
  ArrowSource,
  ArtBoardCursorMode,
  ArtBoardMode,
} from '@store/reducers/artboard/types'

type RevealSectionPayload = Partial<{ skipWhenVisible: boolean }> & WithId

type ShowStructurePayload = {
  showStructure: boolean
}

type ShowAiChatPayload = {
  showAiChat: boolean
}

type DragStartPayload = {
  elementPosition: { x: number; y: number }
  startPosition: { x: number; y: number }
  dragged: {
    type: DRAGGABLE_TYPE
    id: string
    data: any
    ids?: string[]
  }
}

type DragSetDropzonePayload = {
  id: string
  type: DROPZONE_TYPE
  data: any
}

type StatusPayload = {
  status: boolean
}

export const artBoardActions = {
  setSocketOffline: createAction<boolean>('SET_SOCKET_OFFLINE'),
  setSaveFailed: createAction<boolean>('SET_SAVE_FAILED'),
  changeMode: createAction<ArtBoardMode>('CHANGE_MODE'),
  startArrows: createAction<ArrowSource>('START_ARROWS'),
  setEditingArrowLabel: createAction<ID | null>('SET_EDITING_ARROW_LABEL'),
  setSelectedArrowLabel: createAction<ID | null>('SET_SELECTED_ARROW_LABEL'),
  showStructure: createAction<ShowStructurePayload>('SHOW_STRUCTURE'),
  showAiChat: createAction<ShowAiChatPayload>('SHOW_AI_CHAT'),
  setWireframesMultiple: createAction<boolean>('SET_WIREFRAMES_MULTIPLE'),
  setPreview: createAction<string | null>('SET_PREVIEW'),
  setIsEmbed: createAction('SET_IS_EMBED'),
  dragStart: createAction<DragStartPayload>('DRAG_START'),
  dragStop: createAction('DRAG_STOP'),
  dragSetActive: createAction('DRAG_SET_ACTIVE'),
  dragSetDropzone: createAction<DragSetDropzonePayload>('DRAG_SET_DROPZONE'),
  dragResetDropzone: createAction('DRAG_RESET_DROPZONE'),
  setThreadTarget: createAction<ID | null>('SET_THREAD_TARGET'),
  setAiGeneratingStatus: createAction<StatusPayload>(
    'SET_AI_GENERATING_STATUS'
  ),
  setActivityHistoryStatus: createAction<StatusPayload>(
    'SET_ACTIVITY_HISTORY_STATUS'
  ),
  setCursorMode: createAction<ArtBoardCursorMode>('SET_CURSOR_MODE'),
  jumpToThread: createAction<WithId>('JUMP_TO_THREAD'),
  jumpToPage: createAction<WithId>('JUMP_TO_PAGE'),
  revealSection: createAction<RevealSectionPayload>('REVEAL_SECTION'),
}
